import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateLeadCustomFieldValue as UpdateLeadCustomFieldValueMutation,
    UpdateLeadCustomFieldValueVariables,
    UpdateLeadInputFieldInput,
    GetLead_lead as Lead,
} from 'nutshell-graphql-types';

import UPDATE_LEAD_CUSTOM_FIELD_VALUE from '../../../shared/graphql/mutations/update-lead-custom-field-value.graphql';

export const useUpdateLeadPriority = (): {
    updateLeadPriority: (params: {input: UpdateLeadInputFieldInput; lead: Lead}) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateLeadPriority, {loading, error}] = useMutation<
        UpdateLeadCustomFieldValueMutation,
        UpdateLeadCustomFieldValueVariables
    >(UPDATE_LEAD_CUSTOM_FIELD_VALUE);

    return {
        updateLeadPriority: ({input, lead}: {input: UpdateLeadInputFieldInput; lead: Lead}) =>
            updateLeadPriority({
                variables: {lead: input},
                optimisticResponse: {
                    // @ts-expect-error
                    __typename: 'Mutation',
                    updateLead: {
                        __typename: 'UpdateLeadPayload',
                        lead: {
                            // @ts-expect-error
                            __typename: 'Lead',
                            ...lead,
                            priority: input.priority ?? 'NORMAL',
                            isHot: input.priority === 'HOT',
                            avatarUrl:
                                lead.status === 'OPEN'
                                    ? lead.avatarUrl.slice(0, -1) +
                                      (input.priority === 'HOT' ? '1' : '0')
                                    : lead.avatarUrl,
                        },
                    },
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
